import { render } from "./PublicStepOne.vue?vue&type=template&id=31ff56fd&scoped=true"
import script from "./PublicStepOne.vue?vue&type=script&lang=js"
export * from "./PublicStepOne.vue?vue&type=script&lang=js"

import "./PublicStepOne.vue?vue&type=style&index=0&id=31ff56fd&scoped=true&lang=css"

import exportComponent from "/Users/diekstra/PhpstormProjects/rbs-vlb-reservations/rvr-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ff56fd"]])

export default __exports__